import React from 'react';
import  Layout from './features/layout/Layout';

import './App.scss';


function App() {
  return (
    <div style={{width: "100%", height: "100%"}}>
      <div className="App">
        <Layout />
      </div>
    </div>
  );
}

export default App;
